/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SystemStatusMessageTargetAttributeDTO,
    SystemStatusMessageTargetAttributeDTOFromJSON,
    SystemStatusMessageTargetAttributeDTOFromJSONTyped,
    SystemStatusMessageTargetAttributeDTOToJSON,
} from './SystemStatusMessageTargetAttributeDTO';

/**
 * 
 * @export
 * @interface SystemStatusMessageDTO
 */
export interface SystemStatusMessageDTO {
    /**
     * 
     * @type {Date}
     * @memberof SystemStatusMessageDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SystemStatusMessageDTO
     */
    stopDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessageDTO
     */
    messageType?: SystemStatusMessageDTOMessageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessageDTO
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessageDTO
     */
    messageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemStatusMessageDTO
     */
    author?: string;
    /**
     * 
     * @type {Array<SystemStatusMessageTargetAttributeDTO>}
     * @memberof SystemStatusMessageDTO
     */
    targetAttributes?: Array<SystemStatusMessageTargetAttributeDTO>;
}

/**
* @export
* @enum {string}
*/
export enum SystemStatusMessageDTOMessageTypeEnum {
    Info = 'INFO',
    Warning = 'WARNING',
    Critical = 'CRITICAL'
}

export function SystemStatusMessageDTOFromJSON(json: any): SystemStatusMessageDTO {
    return SystemStatusMessageDTOFromJSONTyped(json, false);
}

export function SystemStatusMessageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemStatusMessageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'stopDate': !exists(json, 'stopDate') ? undefined : (new Date(json['stopDate'])),
        'messageType': !exists(json, 'messageType') ? undefined : json['messageType'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageId': !exists(json, 'messageId') ? undefined : json['messageId'],
        'author': !exists(json, 'author') ? undefined : json['author'],
        'targetAttributes': !exists(json, 'targetAttributes') ? undefined : ((json['targetAttributes'] as Array<any>).map(SystemStatusMessageTargetAttributeDTOFromJSON)),
    };
}

export function SystemStatusMessageDTOToJSON(value?: SystemStatusMessageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'stopDate': value.stopDate === undefined ? undefined : (value.stopDate.toISOString()),
        'messageType': value.messageType,
        'message': value.message,
        'messageId': value.messageId,
        'author': value.author,
        'targetAttributes': value.targetAttributes === undefined ? undefined : ((value.targetAttributes as Array<any>).map(SystemStatusMessageTargetAttributeDTOToJSON)),
    };
}

